import { useNavigate } from "react-router-dom";
import { useState } from "react";
import GetVehicleType from "../../Services/GetVehicleType";

const AddVehicleType = ({ onVehicleAdded }) => {
  const navigate = useNavigate();

  // State for form values
  const [vehicleData, setVehicleData] = useState({
    name: "",
    description: "",
    passenger_capacity: "",
    cargo_capacity: "",
    fuel_type: "PETROL", // Default value
    photo_url: null,
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setVehicleData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create a FormData object to handle file upload
    const formData = new FormData();
    for (const key in vehicleData) {
      formData.append(key, vehicleData[key]);
    }

    try {
      // const response = await fetch(
      //   "http://localhost:8000/api/v1/admin/add-vehicle-type",
      //   {
      //     method: "POST",
      //     body: formData,
      //   },
      // );

      const response = await GetVehicleType.createVehicleType(formData);

      if (!response.success) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to create vehicle type");
      }

      const data = await response.data;
      console.log("Vehicle type created:", data);

      // Call the onVehicleAdded function to update the vehicle types in the parent component
      onVehicleAdded(data); // Pass the newly created vehicle type to the parent

      // Optionally, navigate to another page or show a success message
      navigate("/vehicle-type"); // Adjust the route as needed
    } catch (error) {
      console.error("Error submitting form:", error);
      alert(error.message);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 shadow-md rounded-xl">
      <form onSubmit={handleSubmit}>
        {/* Vehicle Name */}
        <div className="form-group">
          <label htmlFor="name">Vehicle Name</label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            placeholder="Enter Vehicle Name"
            value={vehicleData.name}
            onChange={handleChange}
            required
          />
        </div>

        {/* Description */}
        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            placeholder="Enter Vehicle Description"
            value={vehicleData.description}
            onChange={handleChange}
          />
        </div>

        {/* Passenger Capacity */}
        <div className="form-group">
          <label htmlFor="passenger_capacity">Passenger Capacity</label>
          <input
            type="number"
            className="form-control"
            id="passenger_capacity"
            name="passenger_capacity"
            placeholder="Enter Passenger Capacity"
            value={vehicleData.passenger_capacity}
            onChange={handleChange}
          />
        </div>

        {/* Cargo Capacity */}
        <div className="form-group">
          <label htmlFor="cargo_capacity">Cargo Capacity (Liters)</label>
          <input
            type="number"
            className="form-control"
            id="cargo_capacity"
            name="cargo_capacity"
            placeholder="Enter Cargo Capacity"
            value={vehicleData.cargo_capacity}
            onChange={handleChange}
          />
        </div>

        {/* Fuel Type */}
        <div className="form-group">
          <label htmlFor="fuel_type">Fuel Type</label>
          <select
            className="form-control"
            id="fuel_type"
            name="fuel_type"
            value={vehicleData.fuel_type}
            onChange={handleChange}
          >
            <option value="PETROL">Petrol</option>
            <option value="DIESEL">Diesel</option>
            <option value="ELECTRIC">Electric</option>
            <option value="HYBRID">Hybrid</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="vehicle_type">Vehicle Type</label>
          <select
            className="form-control"
            id="vehicle_type"
            name="vehicle_type"
            value={vehicleData.fuel_type}
            onChange={handleChange}
          >
            <option value="CAR">Car</option>
            <option value="Motorcycle">Motorcycle</option>
            <option value="CNG">CNG</option>
          </select>
        </div>

        {/* Add Vehicle Image */}
        <div className="form-group">
          <label htmlFor="photo_url">Add Vehicle Image</label>
          <input
            type="file"
            className="form-control"
            id="photo_url"
            name="photo_url"
            onChange={handleChange}
            accept="image/*"
          />
        </div>

        {/* Footer with Buttons */}
        <div className="d-flex justify-content-between mt-4">
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddVehicleType;
